import { Worklist } from "features/WorklistTools/shared/interfaces";
import { useAppReduxSelector } from "hooks/reduxHooks";
import {
  buildCompoundPlateWorklist,
  buildIntToDestWorklist,
  buildMappingFileWorklist,
  buildNucToIntWorklist,
  buildNucWashWorklist,
  buildSrcToNucWorklist,
} from "../NucleofectionToolHelpers";
import { NucleofectionInternalAction } from "./action";
import { useNucleofectionStateProvider } from "./StateProvider";

export const useHandleMethodSettingsUpdated = () => {
  const { nucleofectionDispatch } = useNucleofectionStateProvider();
  return (key: string, value: any) => {
    nucleofectionDispatch({
      type: NucleofectionInternalAction.UPDATE_METHOD_SETTINGS,
      payload: {
        key,
        value,
      },
    });
  };
};

export const useSetWorklist = () => {
  const { nucleofectionDispatch } = useNucleofectionStateProvider();
  return (worklist: any[]) => {
    nucleofectionDispatch({
      type: NucleofectionInternalAction.SET_WORKLIST,
      payload: {
        worklist: worklist,
        worklistPreviewOpen: true,
      },
    });
  };
};

export const useSetWorkistPreviewOpen = () => {
  const { nucleofectionDispatch } = useNucleofectionStateProvider();
  return (worklistPreviewOpen: boolean) => {
    nucleofectionDispatch({
      type: NucleofectionInternalAction.SET_WORKLIST_PREVIEW_OPEN,
      payload: {
        worklistPreviewOpen: worklistPreviewOpen,
      },
    });
  };
};

export const useGenerateWorklistClick = () => {
  const { nucleofectionInternalState, nucleofectionDispatch } =
    useNucleofectionStateProvider();

  const worklistValues = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.worklistValues
  );
  const compoundPlateInfo = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.compoundPlateInfo
  );
  const sourcePlateInfo = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.sourcePlateInfo
  );
  const nucPlateInfo = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.nucPlateInfo
  );
  const intPlateInfo = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.intPlateInfo
  );
  const destPlateInfo = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.destPlateInfo
  );
  const destSampleType =
    nucleofectionInternalState.methodSettings.destSampleType;

  const compoundPlate = buildCompoundPlateWorklist(
    compoundPlateInfo,
    sourcePlateInfo
  );
  const srcToNuc = buildSrcToNucWorklist(
    compoundPlateInfo,
    sourcePlateInfo,
    nucPlateInfo,
    worklistValues.sourceToNuc
  );
  const nucToInt = buildNucToIntWorklist(
    nucPlateInfo,
    intPlateInfo,
    worklistValues.nucToInt
  );
  const intToDest = buildIntToDestWorklist(
    destPlateInfo,
    intPlateInfo,
    worklistValues.intToDest
  );
  const nucWash = buildNucWashWorklist(nucPlateInfo);
  const mappingFileKeywords = buildMappingFileWorklist(
    compoundPlateInfo,
    sourcePlateInfo,
    nucPlateInfo,
    intPlateInfo,
    destPlateInfo,
    destSampleType
  );

  return () => {
    const worklist: Worklist[] = [
      ...compoundPlate,
      ...srcToNuc,
      ...nucToInt,
      ...intToDest,
      ...nucWash,
      ...mappingFileKeywords,
    ];
    nucleofectionDispatch({
      type: NucleofectionInternalAction.SET_WORKLIST,
      payload: {
        worklist,
        worklistPreviewOpen: true,
      },
    });
  };
};
